import { Component } from 'react'
import { BountyAppState, Reward, RewardsFilter } from 'interfaces/bounty'
import { RewardsHistoryItemWithId } from 'components/features/rewards/rewardPage/store'
import Table2 from 'components/molecules/tables/Table2'
import { WithMobileProps } from 'hocs/withMobile/withMobile'
import RewardRow from 'components/features/pfm/RewardDetails/RewardDetailsRow'
import RewardRowMobile from 'components/features/pfm/RewardDetails/RewardDetailsRowMobile'
import RewardDetailsTableHeader from 'components/features/pfm/RewardDetails/RewardDetailsTableHeader'
import { Transaction } from 'interfaces/moneyflow'
import { Collection, Omit } from 'interfaces'
import { Table2StateProps, TableDispatchProps } from 'components/molecules/tables/Table'
import { PaginatorStateProps } from 'components/molecules/tables/Paginator'
import { PageSizeSelectorStateProps } from 'components/atoms/tables/PageSizeSelector'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import RewardDetailsTabsContainer from 'components/features/pfm/RewardDetailsTabs/RewardDetailsTabsContainer'
import { Modal } from 'components/features/pfm/RewardDetails/Modal'
import Pagination from 'components/features/pfm/Pagination/Pagination'
import * as styles from 'components/features/pfm/RewardDetails/RewardDetails.css'
import { RewardAppState } from 'interfaces/bounty'

export type RewardDetailsStateProps =
  & Omit<Table2StateProps<Transaction>, 'rows'>
  & {
    pageSize: PageSizeSelectorStateProps
    paginator: PaginatorStateProps
    rowsCollection: Collection<RewardsHistoryItemWithId, 'uniqKey'>
    activeFilter: RewardsFilter
    isModalOpened: boolean
    modalType: RewardAppState['modalType']
    dismissingId: Reward['id'] | null
  }

export type RewardDetailsDispatchProps =
  & TableDispatchProps
  & {
    onProgressClick: (modalType: BountyAppState['reward']['modalType']) => void
    onCloseModalClick: () => void
    onDismissClick: (reward: Reward) => void
    onOpenCryptoDetails: (cryptoOrderId: string) => void
  }

type RewardDetailsProps =
  & RewardDetailsDispatchProps
  & RewardDetailsStateProps
  & WithMobileProps

const getRowKey = ({ uniqKey: id }: RewardsHistoryItemWithId) => String(id)

class RewardDetails extends Component<RewardDetailsProps> {
  render () {
    const {
      isModalOpened,
      modalType,
      onCloseModalClick,
    } = this.props

    return (
      <>
        { this.renderMain() }
        { isModalOpened && (
          <Modal rewardType={ modalType } onCloseClick={ onCloseModalClick } />
        ) }
      </>
    )
  }

  renderMain () {
    const {
      activeFilter,
      isMobile,
      isLoading,
      dismissingId,
      rowsCollection,
      onProgressClick,
      onDismissClick,
      onOpenCryptoDetails,
    } = this.props
    const rows = getItemsFromCollection(rowsCollection)
    const RowComponent = isMobile ? RewardRowMobile : RewardRow
    const hasNoRewardsAtAll = activeFilter === 'all' && !rows.length
    const zeroState = !rows.length

    const renderRows = () => (
      <Table2.RowTemplate>
        {
          (row: RewardsHistoryItemWithId) => (
            <RowComponent
              key={ row.uniqKey }
              row={ row }
              isDismissing={ String(dismissingId) === row.uniqKey }
              onDismissClick={ () => onDismissClick(row as Reward) }
              onProgressClick={ onProgressClick }
              onOpenCryptoDetails={ onOpenCryptoDetails }
            />
          )
        }
      </Table2.RowTemplate>
    )

    return (
      <div className={ styles.rewardDetails }>
        { !hasNoRewardsAtAll && this.renderTabs() }
        <Table2
          getRowKey={ getRowKey }
          rows={ rows }
          isLoading={ isLoading }
        >
          { this.renderTableHeader(zeroState) }
          <Table2.Rows>
            { zeroState ? this.renderZeroState() : renderRows() }
          </Table2.Rows>
        </Table2>
        { !zeroState && <Pagination { ...this.props } /> }
      </div>
    )
  }

  renderTabs () {
    return (
      <RewardDetailsTabsContainer />
    )
  }

  renderZeroState () {
    const { activeFilter } = this.props
    const hasNoRewardsAtAll = activeFilter === 'all'

    return (
      <tr>
        <td className={ styles.zeroState } colSpan={ 6 } >
          You have no { hasNoRewardsAtAll ? '' : activeFilter } rewards.
        </td>
      </tr>
    )
  }

  renderTableHeader (zeroState: boolean) {
    if (this.props.isMobile) {
      return null
    }

    return (
      <Table2.HeadRowMarker>
        <RewardDetailsTableHeader zeroState={ zeroState } />
      </Table2.HeadRowMarker>
    )
  }
}

export default RewardDetails
